import React, { useState, useEffect } from 'react'
import { Tabs} from 'antd'
import Main from '../cpn/Main';
import { ScheduleOutlined, PlusOutlined } from '@ant-design/icons';
import BankDocumentList from './BankDocumentList';
import BankRecordList from './BankRecordList';
function BankList(props) {
    const [activeKey, setActiveKey] = useState(localStorage.getItem('jtg-caiwu_bank_active_key') || '1');
    const [items,setItems] = useState([]);
    useEffect(() => {
        if(props.bankAccountList){
            const arr = props.bankAccountList.map(item => {
                return {
                    key: item.qyyhzh_id,
                    label: item.qyyhzh_name + '(期初余额：￥' + item.qyyhzh_qc_amount + ',期初日期：' + item.qyyhzh_qc_date + ')',
                    icon: <ScheduleOutlined />,
                    children: <BankRecordList 
                        qy_id={props.qy_id} 
                        qy_name={props.qy_name} 
                        yh_id={props.yh_id} 
                        yh_name={props.yh_name} 
                        yh_qx={props.yh_qx}
                        bankRemain={item.qyyhzh_qc_amount}
                        qyyhzh_id={item.qyyhzh_id===activeKey ? item.qyyhzh_id : ''}
                    />,
                }
            })
            setItems([
                {
                    key: '1',
                    label: '待记账单据',                        
                    icon: <PlusOutlined />,
                    children: <BankDocumentList 
                        qy_id={props.qy_id} 
                        qy_name={props.qy_name} 
                        yh_id={props.yh_id} 
                        yh_name={props.yh_name} 
                        yh_qx={props.yh_qx}
                        bankAccountList={props.bankAccountList}
                        deptList={props.deptList}
                    />,
                },...arr
            ]);
        }
        
    }, [props,activeKey]);
    return (
        <Main 
            selectedKeys={['/TransferList']}
            qy_id={props.qy_id}
            qy_name={props.qy_name}
            yh_id={props.yh_id}
            yh_name={props.yh_name}
            loanNeedApproveNum={props.loanNeedApproveNum}
            loanNeedReadNum={props.loanNeedReadNum}
            loanRejectedNum={props.loanRejectedNum}
            loanEndNeedReadNum={props.loanEndNeedReadNum}
            reportRejectedNum={props.reportRejectedNum}
            reportNeedApproveNum={props.reportNeedApproveNum}
            reportNeedReadNum={props.reportNeedReadNum}
            expenseNeedApproveNum={props.expenseNeedApproveNum}
            expenseNeedReadNum={props.expenseNeedReadNum}
            expenseRejectedNum={props.expenseRejectedNum}
            expenseEndNeedReadNum={props.expenseEndNeedReadNum}
            ddzcNeedApproveNum={props.ddzcNeedApproveNum}
            ddzcNeedReadNum={props.ddzcNeedReadNum}
            ddzcRejectedNum={props.ddzcRejectedNum}
            ddzcEndNeedReadNum={props.ddzcEndNeedReadNum}
            ddsrNeedApproveNum={props.ddsrNeedApproveNum}
            ddsrNeedReadNum={props.ddsrNeedReadNum}
            ddsrRejectedNum={props.ddsrRejectedNum}
            ddsrEndNeedReadNum={props.ddsrEndNeedReadNum}
            invoiceNeedApproveNum={props.invoiceNeedApproveNum}
            invoiceNeedReadNum={props.invoiceNeedReadNum}
            invoiceRejectedNum={props.invoiceRejectedNum}
            invoiceEndNeedReadNum={props.invoiceEndNeedReadNum}
        >
            <Tabs
                items={items}
                activeKey={activeKey}
                onChange={(key) => {
                    setActiveKey(key)
                    localStorage.setItem('jtg-caiwu_bank_active_key', key)
                }}
            />
        </Main>
    )
}

export default BankList